<template>
  <div style="height: 100%">
    <!-- v-if="$_GNOVA.Project != 'zh'" -->
    <home-header v-if="!hideHeader"></home-header>
    <!-- :class="[$_GNOVA.Project == 'zh' ? 'home-layout' : 'home-layout-head']" -->
    <a-layout :class="!hideHeader ? 'home-layout-head' : 'home-layout'">
      <home-sidebar v-if="!hideLeftMenu"></home-sidebar>
      <a-layout class="home-content">
        <a-layout-content
          :style="{
            background: '#fff',
            padding: '0',
            margin: 0,
            height: '100%'
          }"
        >
          <router-view></router-view>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
<script>
import { mapState } from "vuex";
import HomeHeader from "./components/Header";
import HomeSidebar from "./components/Sidebar";
export default {
  name: "Home",
  data() {
    return {};
  },
  components: {
    HomeHeader,
    HomeSidebar
  },
  computed: {
    ...mapState(["hideHeader", "hideLeftMenu", "userMenuPower"])
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.name === "Home") {
        vm.$router.push({ name: vm.userMenuPower.menus[0].name });
      }
    });
  }
};
</script>

<style lang="less">
.home-layout {
  height: 100% !important;
}
.home-layout-head {
  height: calc(100vh - 64px) !important;
}
.home-content {
  height: 100% !important;
  padding: 5px !important;
}

.ant-checkbox-disabled + span {
  color: rgba(197, 197, 197, 0.64) !important;
}
</style>
